import React from 'react';

import BasicExample from './BasicExample';

import AsyncExample from './AsyncExample';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Jumbotron from 'react-bootstrap/Jumbotron';

import Container from 'react-bootstrap/Container';


//import './Svtoast.css'
import SVRAiport from './SVRAirport';
import './AppTa.css'


const AppTa = () => (
  <Container>
    <Row>
        <Col> <p>Getting sadsadasvfvaf</p></Col>
        <Col xs={1}><SVRAiport/></Col>
        <Col>3 of 3</Col>
      </Row>
     
  
  </Container>
);


export default AppTa;

/*latesworking


const AppTa = () => (
  <Container className="p-3">
    <Jumbotron>
      <h1 className="header">Welcome To React-Bootstrap</h1>
      <AsyncExample/>
    </Jumbotron>
  </Container>
);


const AppTa = () => (
  <Container className="p-3">
    <Jumbotron>
      <h1 className="header">Welcome To React-Bootstrap</h1>
      <BasicExample/>
    </Jumbotron>
  </Container>
);

*/
/*

function App() {
  return (
    <div className="App">
      <h1>Counter Using useSelector</h1>
      <BasicExample/>
    </div>
  );
}


export default App;


*/